import { render, staticRenderFns } from "./ReviewConfig.vue?vue&type=template&id=e6b51150&scoped=true&"
import script from "./ReviewConfig.vue?vue&type=script&lang=js&"
export * from "./ReviewConfig.vue?vue&type=script&lang=js&"
import style0 from "./ReviewConfig.vue?vue&type=style&index=0&id=e6b51150&scoped=true&lang=css&"
import style1 from "./ReviewConfig.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6b51150",
  null
  
)

export default component.exports